import React, { memo } from 'react';
import { TableCell, TableRow } from '@mui/material';
import PropTypes from 'prop-types';

function Row({
  row, actions, active, getControlTP,
}) {
  return (
    <TableRow
      key={row.id}
      onClick={(e) => actions.onActivateRow(e, row.id)}
      selected={active}
      hover
    >
      <TableCell>
        {getControlTP('datefrom', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('first_name', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('second_name', row.id)}
      </TableCell>
      <TableCell>
        {getControlTP('last_name', row.id)}
      </TableCell>
    </TableRow>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    datefrom: PropTypes.string,
    first_name: PropTypes.string,
    second_name: PropTypes.string,
    last_name: PropTypes.string,
  }).isRequired,
  fields: PropTypes.shape({
    member: PropTypes.shape({ read_only: PropTypes.bool, resource: PropTypes.string }),
  }).isRequired,
  actions: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    onActivateRow: PropTypes.func.isRequired,
  }).isRequired,
  active: PropTypes.bool,
  errors: PropTypes.shape({ member: PropTypes.arrayOf(PropTypes.string) }),
  getControlTP: PropTypes.func.isRequired,
};

Row.defaultProps = {
  active: false,
  errors: null,
};

export default memo(Row);
